import React, {Component} from 'react'
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Dialog, DialogActions, DialogContent, DialogTitle,
  FormControl,
  FormHelperText,
  IconButton,
  MenuItem, Select,
  Typography
} from '@material-ui/core';
import {Close, Delete, Done} from '@material-ui/icons'
import localization from '../../config/localization';
import {request} from '../../api-client';
import GlobalSnackbar, {GlobalSnackbarTypes} from '../../components/Letflow/Snackbar/GlobalSnackbar';
import GlobalConfirmationDialog from '../../components/Letflow/Dialog/GlobalConfirmationDialog';
import TranslatableInputs from "../../components/Letflow/TranslatableInputs";
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import AsyncSelect from "react-select/lib/Async";
import HomeElementCreateDialogTagSelection from "./HomeElementCreateDialogTagSelection";
import HomeElementStyleSelection from "./HomeElementStyleSelection";

export const dataSourceTypes = [
  {value: 'home', label: localization.get(`data_source.home`)},
  {value: 'content_creator_audiovisual', label: localization.get(`data_source.content_creator_audiovisual`)},
  {value: 'content_creator_talent', label: localization.get(`data_source.content_creator`)},
  {value: 'video_content_creation', label: localization.get(`data_source.video_content_creation`)},
  {value: 'smart_search', label: localization.get(`advanced_search`)},
  {value: 'my_list', label: localization.get(`my_list`)},
  {value: 'drop_down', label: localization.get(`data_source.drop_down`)},
  {value: 'link', label: localization.get(`links`)},
  {value: 'playlist', label: localization.get(`data_source.channel_playlist`)},
  {value: 'section', label: localization.get(`section`)},
];


export const checkDataSourcesAgainstPermissions = (dataSourceTypes, parent = null, isNavbar = false) => {
  let dataSourceTypesUpdated = dataSourceTypes;
  //if(!!channel) creatingElements = !!channel.creatingElements


  if(parent && parent.id) {
    dataSourceTypesUpdated = dataSourceTypesUpdated.filter(dataSourceType => dataSourceType.value !== 'my_list')
    dataSourceTypesUpdated = dataSourceTypesUpdated.filter(dataSourceType => dataSourceType.value !== 'home')
    dataSourceTypesUpdated = dataSourceTypesUpdated.filter(dataSourceType => dataSourceType.value !== 'drop_down')
  }

  if(!isNavbar) {
    dataSourceTypesUpdated = dataSourceTypesUpdated.filter(dataSourceType => dataSourceType.value !== 'link')
    dataSourceTypesUpdated = dataSourceTypesUpdated.filter(dataSourceType => dataSourceType.value !== 'my_list')
    dataSourceTypesUpdated = dataSourceTypesUpdated.filter(dataSourceType => dataSourceType.value !== 'smart_search')
    dataSourceTypesUpdated = dataSourceTypesUpdated.filter(dataSourceType => dataSourceType.value !== 'contact_form')
    dataSourceTypesUpdated = dataSourceTypesUpdated.filter(dataSourceType => dataSourceType.value !== 'home')
    dataSourceTypesUpdated = dataSourceTypesUpdated.filter(dataSourceType => dataSourceType.value !== 'drop_down')
    dataSourceTypesUpdated = dataSourceTypesUpdated.filter(dataSourceType => dataSourceType.value !== 'section')
  }

  return dataSourceTypesUpdated
};

class HomeGridAndCarouselBase extends Component {

  constructor(props) {
    super(props)
    this.originalTitle = props.title || ''
    this.originalDataSource = props.data_source
    this.originalColumns = props.columns || 4
    this.originalIncludeGold = props.include_gold || 0

    this.state = {
      titleEs: props.translations ? ((props.translations.find(translation => translation.locale === 'es')) ? props.translations.find(translation => translation.locale === 'es').title : '') : "",
      titleEn: props.translations ? ((props.translations.find(translation => translation.locale === 'en')) ? props.translations.find(translation => translation.locale === 'en').title : '') : "",
      titlePt: props.translations ? ((props.translations.find(translation => translation.locale === 'pt')) ? props.translations.find(translation => translation.locale === 'pt').title : '') : "",
      dataSource: this.findDataSource(props.data_source, props.contentCreatorTypes),
      columns: props.columns || 4,
      requestingUpdate: false,
      includeGold: props.include_gold || 0,
      rowsToShow: props.rows_to_show || 4,
      dataSourceTypes: dataSourceTypes,
      onlyImage: props.only_image,
      selectedTags: (props.tags && props.tags.length > 0) ? props.tags : [],
      unselectedTags: (props.not_tags && props.not_tags.length > 0) ? props.not_tags : [],
      tagGroups: [],
      openTagsDialog: false,
      contentCreatorTypes: props.contentCreatorTypes || [],
      contentCreatorTypesForCreations:  props.contentCreatorTypes.map(creators => ({value: creators.id, label: creators.label, slug: creators.value})) || [],
      contentCreatorType: props.content_creator_type,
      tagsAlreadyRequested: false,
      selectedContentCreatorTypes: !!props.content_creators_ids ? props.contentCreatorTypes.filter(creator => props.content_creators_ids.includes(creator.id.toString())).map(creators => ({value: creators.id, label: creators.creation || creators.label, slug: creators.value})) : [],
      shape: props.shape,
      numbered: props.numbered || false,
      fixedTitle: props.fixed_title || false,
      withBackground: props.with_background || false,
      navbarViewType: "grid",
      link: props.link || "",
      featuredType: props.inverted ? 'inverted' : props.editorial ? 'editorial' : 'default',
      availablePlaylists: props.availablePlaylists || [],
      playlist: (props.playlist_id && props.availablePlaylists) ? props.availablePlaylists.find(item => item.value === props.playlist_id) : null,
      sections: props.sections || []
    }
  }

  componentDidMount = () => {
    this.setState({dataSourceTypes: checkDataSourcesAgainstPermissions( dataSourceTypes, this.props.parent, this.props.isNavbar)})
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.permissions !== nextProps.permissions) {
      this.setState({dataSourceTypes: checkDataSourcesAgainstPermissions(dataSourceTypes, this.props.parent, this.props.isNavbar)})
    }

    if (nextProps.contentCreatorTypes !== this.state.contentCreatorTypes) {
      this.setState({
        contentCreatorTypes: nextProps.contentCreatorTypes,
        contentCreatorTypesForCreations: nextProps.contentCreatorTypes.filter(creators => creators.allowVideo || creators.allowAudio ).map(creators => ({value: creators.id, label: creators.label, slug: creators.value})) || [],
        dataSource: this.findDataSource(this.state.dataSource, nextProps.contentCreatorTypes),
        selectedContentCreatorTypes: this.props.content_creators_ids ? nextProps.contentCreatorTypes.filter(creator => this.props.content_creators_ids.includes(creator.id.toString())).map(creators => ({value: creators.id, label: creators.creation || creators.label, slug: creators.value})) : []
      })
    }
  }

  findDataSource = (dataSource, contentCreatorTypes) => {
    if (dataSource !== 'content_creator') {
      return dataSource
    } else {
      let talentTypes = contentCreatorTypes.map(type => type.isTalent && type.value)
      let audiovisualTypes = contentCreatorTypes.map(type => !type.isTalent && type.value)

      if (talentTypes.includes(this.props.content_creator_type)) {
        return 'content_creator_talent'
      }
      if (audiovisualTypes.includes(this.props.content_creator_type)) {
        return 'content_creator_audiovisual'
      }
      return dataSource
    }
  }

  onChange = e => {
    this.setState({[e.target.id || e.target.name]: e.target.value})
    if ( e.target.name !== 'columns' && e.target.name !== 'rowsToShow') {
      this.setState({columns: 4, rowsToShow: 4})
    }
  }
  requestUpdate = () => {
      this.setState({ requestingUpdate: true })
      let data = {
        ...this.state,
        dataSource: this.state.dataSource === 'content_creator_talent' || this.state.dataSource === 'content_creator_audiovisual' ? 'content_creator' : this.state.dataSource,
        playlist: this.state.playlist && this.state.playlist.value
      }
      request.home.update(this.props.id, data)
        .then(response => {
          GlobalSnackbar.show({
            message: localization.get('home_editor.element_updated'),
            type: GlobalSnackbarTypes.SUCCESS,
          })

          this.setState({ requestingUpdate: false, openTagsDialog: false })
          if(this.props.isModal) {
            response.data.title = response.data.translations.filter(trans => trans.title)[0].title

            this.props.onClose(response.data)
          }
        })
        .catch(() => {
          GlobalSnackbar.show({
            message: localization.get('home_editor.element_update_failed'),
            type: GlobalSnackbarTypes.ERROR,
          })
          this.setState({ requestingUpdate: false })
          if(this.props.isModal) {
            this.props.onClose()
          }else{
            this.props.onUpdateFailed()
          }
        })

  }

  clearAllTags = () =>
    new Promise(resolve => {
      this.setState( {tagGroups: this.state.tagGroups.map(tagGroup => {
          return {...tagGroup,
            tags: tagGroup.tags.map(tag => {
              return {...tag, state: 'available'}
            })
          }
        })
      })
      resolve()
    }).then(() => this.setState({selectedTags: [], unselectedTags: []}))

  makeSubmitButton = () => <Button
    onClick={this.requestUpdate}
    disabled={this.state.requestingUpdate || (this.originalTitle === this.state.title && this.originalDataSource === this.state.dataSource && this.state.columns === this.originalColumns && this.state.includeGold === this.originalIncludeGold)}>
    {localization.get('store')}
  </Button>

  requestDelete = () => request.home.delete(this.props.id).then(this.props.onUpdateSuccess).catch(this.props.onUpdateFailed)

  handleDelete = () => GlobalConfirmationDialog.showDelete({ elementName: this.originalTitle, deleteRequest: this.requestDelete })

  onSelectedTagsChanged = selectedTag => {
    if (this.state.selectedTags.includes(selectedTag.toString())) { //Remove from selected / add to unselected tags
      this.state.unselectedTags.push(selectedTag.toString())
      this.setState({
        selectedTags: this.state.selectedTags.filter(tags => tags !== selectedTag.toString()),
        unselectedTags: this.state.unselectedTags
      }, () => this.updateTagColor(selectedTag.toString(), "unselected"))
    }else if(this.state.unselectedTags.includes(selectedTag.toString())) { //Remove from unselected / add to available tags
      this.setState({
        unselectedTags: this.state.unselectedTags.filter(tags => tags !== selectedTag.toString()),
      }, () => this.updateTagColor(selectedTag.toString(), "available"))
    }else { //Remove from available / add to selected tags
      this.state.selectedTags.push(selectedTag.toString());
      this.setState({selectedTags: this.state.selectedTags}, () => this.updateTagColor(selectedTag, "selected"))
    }
  };

  paintAllTags = () =>
    new Promise(resolve => {
      this.state.selectedTags.map(tag => this.updateTagColor(tag, "selected"))
      this.state.unselectedTags.map(tag => this.updateTagColor(tag, "unselected"))
      resolve()
    })

  onEditTags = dataSource => {
    if (dataSource === 'content_creator') {
      request.tagGroup.getAll({filterBy: [{ column: 'type', filter: this.state.contentCreatorType},
          { column: 'creation_group', filter: '0'}]})
        .then(tagGroups => this.setState(state => ({...state, tagGroups})))
        .then(() => this.setState({openTagsDialog: true}))
        .then(() => this.paintAllTags())
    }

    if (dataSource === 'video_content_creation') {
      request.tagGroup.getAll({filterBy: [
          { column: 'types_ids', filter: this.state.selectedContentCreatorTypes.map(type => type.value)},
          { column: 'inheritable', filter: "true"}
        ]})
        .then(tagGroups => this.setState(state => ({...state, tagGroups})))
        .then(() => this.setState({openTagsDialog: true}))
        .then(() => this.paintAllTags())
    }
  }

  updateTagColor = (selectedTag, value) =>
    this.setState( {tagGroups: this.state.tagGroups.map(tagGroup => {
        return {...tagGroup,
          tags: tagGroup.tags.map(tag => {
            if (tag.id.toString() == selectedTag.toString()) {
              return {...tag, state: value}
            }
            return tag
          })
        }
      })
    })

  onTagsTest = () => {
    return request.home.test({
        type: this.state.dataSource === 'content_creator_talent' || this.state.dataSource === 'content_creator_audiovisual' ? 'content_creator' : this.state.dataSource,
        selectedTags: this.state.selectedTags,
        unselectedTags: this.state.unselectedTags,
        contentCreatorType: this.state.contentCreatorType,
        selectedContentCreatorTypes: this.state.selectedContentCreatorTypes
      }
    )
  }

  handleCancel = () => this.setState({openTagsDialog: false})

  renderTagsDialog = () =>
    <Dialog maxWidth={false} open={this.state.openTagsDialog} onEscapeKeyDown={this.handleCancel} onBackdropClick={this.handleCancel}>
      <DialogTitle>{localization.get('home_editor.tag_selection.edit_title')}</DialogTitle>
      <DialogContent style={{maxWidth: 690}}>
        <HomeElementCreateDialogTagSelection clearAllTags={this.clearAllTags} contentCreators={this.state.selectedContentCreatorTypes} tagGroups={this.state.tagGroups} onSelectedTagsChanged={this.onSelectedTagsChanged} onTest={this.onTagsTest} radio={this.state.selectedTags.length > 0 || this.state.unselectedTags.length > 0 ? "filter" : "all"}/>
      </DialogContent>
      <DialogActions>
        <Button onClick={this.handleCancel} disabled={this.state.submitting}><Close /></Button>
        <Button onClick={this.requestUpdate}><Done /></Button>
      </DialogActions>
    </Dialog>


  render = () =>
    <Card style={{ width: '100%', minWidth: 600, overflow: "scroll" }}>
      <CardContent>
        <Typography variant='display1'>{this.props.elementTitle}</Typography>
        <FormControl style={{ width: '100%', marginTop: '10px' }}>
          <ValidatorForm >
            <TranslatableInputs
              ref={instance => this.child = instance}
              translateFromHomeElementRequest={this.requestUpdate}
              children={[
                {
                  language: 'es',
                  content: [
                    <TextValidator
                      style={{ width: "100%", marginBottom: "20px" }}
                      id="titleEs"
                      label={localization.get('home_editor.title')}
                      name="titleEs"
                      value={this.state.titleEs}
                      onChange={this.onChange}
                      validators={['required']}
                      errorMessages={[localization.get('validator.is_required')]}
                    />
                  ]
                },
                {
                  language: 'en',
                  content: [
                    <TextValidator
                      style={{ width: "100%", marginBottom: "20px" }}
                      id="titleEn"
                      label={localization.get('home_editor.title')}
                      name="titleEn"
                      value={this.state.titleEn}
                      onChange={this.onChange}
                      validators={['required']}
                      errorMessages={[localization.get('validator.is_required')]}
                    />
                  ]
                },
                {
                  language: 'pt',
                  content: [
                    <TextValidator
                      style={{ width: "100%", marginBottom: "20px" }}
                      id="titlePt"
                      label={localization.get('home_editor.title')}
                      name="titlePt"
                      value={this.state.titlePt}
                      onChange={this.onChange}
                      validators={['required']}
                      errorMessages={[localization.get('validator.is_required')]}
                    />
                  ]
                }
              ]}
            />
          </ValidatorForm>
          <Select name='dataSource' value={this.state.dataSource} onChange={this.onChange}>
            {this.state.dataSourceTypes.map((dataSourceType, i) =>
              <MenuItem key={i} value={dataSourceType.value}>{dataSourceType.label}</MenuItem>)}
          </Select>
          <FormHelperText>{localization.get('home_editor.data_source')}</FormHelperText>

          {(this.state.dataSource === 'content_creator_talent' || this.state.dataSource === 'content_creator_audiovisual' || this.state.dataSource === 'content_creator') &&
            <React.Fragment>
              <br/>
              <Select name='contentCreatorType' value={this.state.contentCreatorType} onChange={this.onChange}>
                {this.state.contentCreatorTypes
                  .sort((a, b) => (a.label > b.label) ? 1 : -1)
                  .map((contentCreatorType, i) => {
                    if (this.state.dataSource === 'content_creator_talent' && !contentCreatorType.isTalent) {
                      return false
                    }
                    if (this.state.dataSource === 'content_creator_audiovisual' && contentCreatorType.isTalent) {
                      return false
                    }
                    return (
                      <MenuItem key={i} value={contentCreatorType.value}>{contentCreatorType.label}</MenuItem>
                    )
                  })}
              </Select>
              <FormHelperText>{localization.get('content_creator_type')}</FormHelperText>

              <Button style={{marginTop: 20}} onClick={() => this.onEditTags('content_creator')}>{localization.get('home_editor.tag_selection.edit_title')}</Button>

              {this.renderTagsDialog()}
            </React.Fragment>
          }

          {this.state.dataSource === 'video_content_creation' &&
          <React.Fragment>
            <br/>
            <AsyncSelect
              name='selectedContentCreatorTypes'
              id={'selectedContentCreatorTypes'}
              placeholder={localization.get('conversation.filter_users')}
              loadingMessage={() => localization.get('loading')}
              isMulti
              autoload
              autoBlur={true}
              backspaceRemoves={false}
              noOptionsMessage={() => localization.get('no_options')}
              value={this.state.selectedContentCreatorTypes}
              onChange={selectedContentCreatorTypes => this.setState({selectedContentCreatorTypes})}
              defaultOptions={this.state.contentCreatorTypesForCreations}
              loadOptions={(inputValue, callback) => {
                callback(this.state.contentCreatorTypesForCreations.filter(i =>
                  i.label.toLowerCase().includes(inputValue.toLowerCase())
                ))
              }}
            />
            <FormHelperText>{localization.get('content_creator_type')}</FormHelperText>

            <Button style={{marginTop: 20}} onClick={() => this.onEditTags('video_content_creation')}>{localization.get('home_editor.tag_selection.edit_title')}</Button>
            {this.renderTagsDialog()}

          </React.Fragment>
          }

          {this.state.dataSource === 'playlist' &&
            <React.Fragment>
              <br/>
              <FormHelperText>{localization.get('playlist')}</FormHelperText>
              <AsyncSelect
                name='playlist'
                id={'playlist'}
                placeholder={localization.get('conversation.filter_users')}
                loadingMessage={() => localization.get('loading')}
                autoload
                autoBlur={true}
                noOptionsMessage={() => localization.get('no_options')}
                value={this.state.playlist}
                onChange={playlist => this.setState({playlist})}
                defaultOptions={this.state.availablePlaylists}
                loadOptions={(inputValue, callback) => {
                  callback(this.state.availablePlaylists.filter(i =>
                    i.label.toLowerCase().includes(inputValue.toLowerCase())
                  ))
                }}
              />
              <br/>
            </React.Fragment>
          }

          {this.state.dataSource === 'link' &&

            <FormControl style={{ width: '100%', marginTop: '10px' }}>
              <ValidatorForm >
              <TextValidator
                style={{ width: "100%", marginBottom: "20px" }}
                label={localization.get('url')}
                id="link"
                name="link"
                value={this.state.link}
                onChange={e => this.setState({link: e.target.value})}
                validators={['required']}
                errorMessages={[localization.get('validator.is_required')]}
              />
              </ValidatorForm>
            </FormControl>
          }
          {this.state.dataSource === 'section' &&
            <React.Fragment>
              <br/>
              <FormHelperText>{localization.get('section')}</FormHelperText>
              <AsyncSelect
                name='section'
                id={'section'}
                placeholder={localization.get('conversation.section')}
                loadingMessage={() => localization.get('loading')}
                autoload
                autoBlur={true}
                noOptionsMessage={() => localization.get('no_options')}
                value={this.state.section}
                onChange={section => this.setState({section})}
                defaultOptions={this.state.section}
                loadOptions={(inputValue, callback) => {
                  callback(this.state.sections.filter(i =>
                    i.label.toLowerCase().includes(inputValue.toLowerCase())
                  ))
                }}
              />
              <br/>
            </React.Fragment>
          }

          {!['home', 'link', 'drop_down', 'my_list', 'contact_form', 'section'].includes(this.state.dataSource) &&
            <HomeElementStyleSelection
              type={this.props.type !== 'navbar' ? this.props.type : this.props.view_type}
              shape={this.state.shape}
              fixedTitle={this.state.fixedTitle}
              withBackground={this.state.withBackground}
              numbered={this.state.numbered}
              onlyImage={this.state.onlyImage}
              columns={this.state.columns}
              rowsToShow={this.state.rowsToShow}
              onChange={this.onChange}
              onCheckboxChange={name => this.setState({[name]: !this.state[name]})}
              featuredType={this.state.featuredType}
            />
          }
        </FormControl>
      </CardContent>
      <CardActions style={{ float: 'right' }}>
        {!this.props.isModal && <IconButton onClick={this.handleDelete}><Delete /></IconButton>}
        {this.makeSubmitButton()}
      </CardActions>
    </Card>
}

export default HomeGridAndCarouselBase
